// Returns YYYY-MM-DD for "today" anchored to Australia/Brisbane (AEST,
// no DST). Mirrors backend/src/models/tracking.ts so frontend status
// derivation matches the timezone the backend uses for compliance
// comparisons. Without this, a user in Perth at 23:30 local would render
// different statuses than a user on the east coast at the same instant.
//
// The Intl.DateTimeFormat is built once at module scope: constructing it
// loads locale/timezone data and is the dominant cost here, while this
// helper is called per-row on the milestone and insurance tabs.

const BRISBANE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Australia/Brisbane",
});

export function getBrisbaneToday(): string {
  return BRISBANE_FMT.format(new Date());
}
